/**
 * @generated SignedSource<<a1cf40f653fe9ad877dac7a34c6dd014>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerOnelineMenuAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null;
  } | null;
  readonly " $fragmentType": "headerOnelineMenuAppConfigQuery";
};
export type headerOnelineMenuAppConfigQuery$key = {
  readonly " $data"?: headerOnelineMenuAppConfigQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerOnelineMenuAppConfigQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerOnelineMenuAppConfigQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "scmp_pwa_oneline_menu"
          }
        }
      ],
      "concreteType": "AppConfig",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_oneline_menu\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "9171d86230ffe9bf3a8cc5b7d72c6f2e";

export default node;
